import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationError, NavigationCancel, RouterOutlet } from '@angular/router';
import { AuthenticationService } from './services/authentication/authentication.service';
import { TranslateService } from '@ngx-translate/core';
import { ConfigLoaderService } from './services/config-loader/config-loader-service';
import { GoogleTagsService } from './services/google-tags/google-tags.service';
import { LoaderSpinnerComponent } from './core/loader-spinner/loader-spinner.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [
    LoaderSpinnerComponent,
    RouterOutlet
  ]
})
export class AppComponent implements OnInit {
  title = 'infoneige';
  public isNavigating = false;
  public isLoading = true;

  constructor(
    public translate: TranslateService,
    private router: Router,
    private configLoaderService: ConfigLoaderService,
    private googleTagsService: GoogleTagsService,
    public authenticationService: AuthenticationService,
  ) {
    
    this.loadHomePageScriptTags();
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  ngOnInit(): void {
    this.router.events.subscribe(
      async (event) => {
        if (event instanceof NavigationStart) {
          this.isNavigating = true;
        }
        if (event instanceof NavigationEnd || event instanceof NavigationError || event instanceof NavigationCancel) {
          await this.delay(300);
          this.isNavigating = false;
        }
      }
    );


  }

  private loadHomePageScriptTags(): void {
    //Google Tag Manager
    let script = document.createElement('script');
    script.innerHTML = this.googleTagsService.getTagManager(this.configLoaderService.GoogleTagManager.containerId);
    document.head.appendChild(script);

    //Google Tag Manager
    let noscript = document.createElement('noscript');
    noscript.innerHTML = this.googleTagsService.getNoscriptTagManager(this.configLoaderService.GoogleTagManager.containerId);
    document.body.appendChild(noscript);
    
    //Global site tag (gtag.js) - Google Analytics
    script = document.createElement('script');
    script.src = this.googleTagsService.getAnaliticsSrc(this.configLoaderService.GoogleAnalytics.measurementId);
    script.async = true;
    document.head.appendChild(script);

    //Global site tag (gtag.js) - Google Analytics
    script = document.createElement('script');
    script.innerHTML = this.googleTagsService.getAnaliticsTag(this.configLoaderService.GoogleAnalytics.measurementId);
    document.head.appendChild(script);

    //Google Firebase
    script = document.createElement('script');
    script.type = 'module';
    const firebase = this.configLoaderService.firebase;
    script.innerHTML = this.googleTagsService.getFirebaseTag(firebase.apiKey,
      firebase.authDomain,
      firebase.databaseURL,
      firebase.projectId,
      firebase.storageBucket,
      firebase.messagingSenderId,
      firebase.appId, firebase.measurementId);
    document.head.appendChild(script);
  }

}
